///Import react section
import React, { Component } from 'react';
import { Translate } from "react-localize-redux";
import autoBind from 'auto-bind';
import { withRouter } from "react-router-dom";
import withauthenticatedLayout from '../layouts/withauthenticatedLayout';
import {loadNotificationNoticeFromBackEnd} from '../../store/noticeChanges/NoticeChangeAction';
import { connect } from 'react-redux';
import {cancelWorflowFromBackend} from '../../store/workflows/workflowActions';
import CancelWorkflow from '../common/CancelWorkflow';

/**
 * On cance notice
 */
class CancelContainer extends Component {

  constructor (props) {
    super(props);
    autoBind(this);
  }

    /**
    * componentDidMount
    */
   componentDidMount() {
        let noticeToken = this.props.match.params.token;
        this.props.loadNotificationNotice(noticeToken);
    }

      /**
     * Cancel a quote from back end
     */
    onCancelWorkflowsDocument(cancelComment, razonForCancel){
      let token =this.props.match.params.token;
      this.props.cancelWorflowFromBackend(token, cancelComment, razonForCancel)
      .then(() =>{
        this.props.history.push(`/noticechanges/notification/${token}`)
      }).catch(() =>{
          this.setState({
              showToaster: true,
              toasterMessage: <Translate id="common.errorToSave" />,
              toasterVariant: "error",
          })
      })
  }

  render () {
        return (
        <CancelWorkflow
            {...this.props}
            workflow= {this.props.notificationNotice}
            onCancelWorkflowsDocument={this.onCancelWorkflowsDocument}
            isSaving={this.props.isCancel}
            link = {'noticechanges/notification'}
        />
    )
  }
}

/**
 *  Defines the properties injecteded from the store to view container
 *
 * @param {*} state
 * @returns
 */
function mapStateToProps(state) {
    let notificationNotice = state.noticechanges.get("notificationNotice");
   return {
      isCancel: state.workflow.get('isCancel'),
      notificationNotice: notificationNotice ? notificationNotice.toJS() : null,
  }
}

/**
 * Defines the actions injectes to the component
 *
 * @param {*} state
 * @returns
 */
const mapDispatchToProps = dispatch => {
  return {
    loadNotificationNotice: (token) => {
        return dispatch(loadNotificationNoticeFromBackEnd(token));
    },
    cancelWorflowFromBackend: (token, cancelComment, razonForCancel) => {
        return dispatch(cancelWorflowFromBackend(token, cancelComment, razonForCancel));
    },
    
  }
}

export default withauthenticatedLayout((withRouter) (connect(mapStateToProps, mapDispatchToProps)(CancelContainer)));